<template>
	<v-container fluid fill-height
		><v-row>
			<v-col cols="12" md="6">
				<v-img
					:src="url"
					:lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
					aspect-ratio="1"
					ref="catimg"
				>
					<template v-slot:placeholder>
						<v-row
							class="fill-height ma-0"
							align="center"
							justify="center"
						>
							<v-progress-circular
								indeterminate
								color="black"
							></v-progress-circular>
						</v-row> </template
				></v-img>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="text-center">
				<v-btn color="success" fab x-large dark @click="randomCat()">
					<v-icon>mdi-cat</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
export default {
	data: function() {
		return {
			url: "https://cataas.com/cat/gif",
			base: "https://cataas.com/cat/gif"
		};
	},
	computed: {},
	methods: {
		randomCat: function(event) {
			var timeStampInMs =
				window.performance &&
				window.performance.now &&
				window.performance.timing &&
				window.performance.timing.navigationStart
					? window.performance.now() +
					  window.performance.timing.navigationStart
					: Date.now();

			this.url = this.base + "?ran=" + timeStampInMs;
		}
	}
};
</script>
